interface Props {
    className?: string;
}

export function CivilResponsibilityIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.51 56.79c-.18-1.44-.27-2.91-.27-4.39 0-19.73 15.99-35.72 35.72-35.72 13.62 0 25.46 7.62 31.49 18.84"
                stroke="currentColor"
                strokeWidth={2.83}
                strokeMiterlimit={10}
            />
            <path
                d="M86.41 48c.18 1.44.27 2.91.27 4.39 0 19.73-15.99 35.72-35.72 35.72-13.62 0-25.46-7.62-31.49-18.84"
                stroke="currentColor"
                strokeWidth={2.83}
                strokeMiterlimit={10}
            />
            <polyline
                points="81.93 51.75 86.41 47.27 90.9 51.75"
                fill="none"
                stroke="currentColor"
                strokeWidth={2.83}
                strokeMiterlimit={10}
            />
            <polyline
                points="20.13 53.41 15.65 57.89 11.17 53.41"
                fill="none"
                stroke="currentColor"
                strokeWidth={2.83}
                strokeMiterlimit={10}
            />

            <path
                d="M62.93 51.73c.08.56.12 1.13.12 1.71 0 6.74-5.46 12.2-12.2 12.2s-12.2-5.46-12.2-12.2 5.46-12.2 12.2-12.2c2.59 0 4.99.81 6.96 2.18"
                stroke="currentColor"
                strokeWidth={2.83}
                strokeMiterlimit={10}
            />
            <polyline
                points="46.13 50.95 52.29 55.93 70.16 37.86"
                fill="none"
                stroke="currentColor"
                strokeWidth={2.83}
                strokeMiterlimit={10}
            />
        </svg>
    );
}
